import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  inject,
} from '@angular/core';

@Directive({ selector: '[appNumeric]' })
export class NumbersOnlyDirective {
  private el = inject(ElementRef);

  @Output() public numericValue = new EventEmitter<string>();
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}/);
  private specialKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'Ctrl', 'v', 'ArrowLeft', 'ArrowRight'];
  @HostListener('input', ['$event'])
  public onKeyDown(event: KeyboardEvent): void {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    // let current: string = this.el.nativeElement.value;
    const current: string = this.el.nativeElement.value;
    const match: RegExpMatchArray = current.match(this.regex);
    this.el.nativeElement.value = match[0];
    this.numericValue.emit(match[0]);
  }
}
